import React from 'react';
import { cn } from '../../../utils';

const Column = ({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={cn('col gap-1', className)} {...props}>
      {children}
    </div>
  );
};

export default Column;
